import React, { FormEvent, MouseEvent } from 'react';

import { Project } from '@qality/common-model';

export interface QAlitySettingsContextProps {
  hasRightsToSeeSettings: boolean;
  isJiraAdminUser: boolean;
  isAppVisibleInAllIssuesForAllProjects: boolean;
  isPluginEnabledForAllProjects: boolean;
  getIsPluginEnabledInAtLeastOneProject: () => boolean;
  projects: Array<any>;
  loading: boolean;
  isInitialized: boolean;
  query: string;
  toggleAppVisibilityInAllIssues: (project: Project, index: number) => void;
  togglePluginInProject: (project: Project, index: number) => void;
  onFilterChange: (event: FormEvent<HTMLInputElement>) => void;
  clearFilter: (event: MouseEvent<HTMLDivElement, any>) => void;
  toggleAppVisibilityInAllIssuesForAllProjects: () => void;
  togglePluginForAllProjects: () => void;
  addTestCaseIssueTypeToProjectScheme: (id: string | number) => void;
  removeTestCaseIssueTypeFromProjectScheme: (id: string | number) => void;
}

const initialValues: QAlitySettingsContextProps = {
  hasRightsToSeeSettings: true,
  isJiraAdminUser: false,
  isAppVisibleInAllIssuesForAllProjects: false,
  isPluginEnabledForAllProjects: false,
  getIsPluginEnabledInAtLeastOneProject: () => undefined,
  projects: [],
  loading: true,
  isInitialized: false,
  query: '',
  toggleAppVisibilityInAllIssues: () => undefined,
  togglePluginInProject: () => undefined,
  onFilterChange: () => undefined,
  clearFilter: () => undefined,
  toggleAppVisibilityInAllIssuesForAllProjects: () => undefined,
  togglePluginForAllProjects: () => undefined,
  addTestCaseIssueTypeToProjectScheme: (id: string | number) => undefined,
  removeTestCaseIssueTypeFromProjectScheme: (id: string | number) => undefined,
};

export const QAlitySettingsContext =
  React.createContext<QAlitySettingsContextProps>(initialValues);
